<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">

    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Configuraciones del Importador y el Lugar de Destino por Taric</h4>

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intCodigoTaric">Código Taric</label>
                                    <input formControlName="CodigoTaric" name="CodigoTaric" class="form-control" maxlength="10" inputStyleClass="form-control" type="text" value="">
                                </div>

                                <div class="form-group col-md-2"></div>

                                <div class="form-group col-md-2">
                                    <div>
                                        <label class="col-form-label" for="Higiene">Higiene</label>
                                        <p-selectButton class="selectButtonCust"
                                                        [options]="listSiNoTodos"
                                                        formControlName="Higiene"
                                                        unselectable="true">
                                        </p-selectButton>
                                    </div>
                                </div>

                                <div class="form-group col-md-2">
                                    <div>
                                        <label class="col-form-label" for="ChedPp">Ched PP</label>
                                        <p-selectButton class="selectButtonCust"
                                                        [options]="listSiNoTodos"
                                                        formControlName="ChedPp"
                                                        unselectable="true">
                                        </p-selectButton>
                                    </div>
                                </div>

                                <div class="form-group col-md-2">
                                    <div>
                                        <label class="col-form-label" for="PcfCanariasSv">PCF Canarias SV</label>
                                        <p-selectButton class="selectButtonCust"
                                                        [options]="listSiNoTodos"
                                                        formControlName="PcfCanariasSv"
                                                        unselectable="true">
                                        </p-selectButton>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" [disabled]="disableSearchBtn"
                                                title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" [disabled]="formIsUntouched()"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
